export default "__VITE_ASSET__CSII$r2l__"